<template>
  <div>
    <v-form v-model="form_valido_variacao" lazy-validation ref="Variacao">
      <z-dialogo
        ref="dialogo"
        largura="700px"
        titulo="Variação"
        dividers
        persistent
        scrollable
        :altura="variacao.id != null ? '335px' : ''" 
        @abrir="$refs.Variacao.resetValidation()"
      >
        <!-- <template #titlebuttons v-if="variacao.id != null">
          <v-btn depressed small color="primary" @click="adicionarValor">
            <v-icon left small>mdi-plus</v-icon>
            Adicionar
          </v-btn>
        </template> -->

        <template v-slot:prepend>
          <div class="pa-4 pb-0">
            <v-row dense>
              <v-col cols="12">
                <z-text-field
                  v-model="variacao.descricao"
                  ref="descricao"
                  label="Descrição"
                  autofocus
                  upper
                  :rules="[regras.campoObrigatorio]"
                ></z-text-field>
              </v-col>
            </v-row>
          </div>
        </template>

        <template late v-slot:conteudo v-if="variacao.id != null">
          <h3 class="text-body-2 mb-3 text--primary">Opções</h3>
          <v-data-table
            :headers="headers"
            :items="variacao.valores"
            item-key="id"
            disable-pagination
            disable-sort
            hide-default-footer
            hide-default-header
          >
            <template v-slot:item="{ item: variacao_valor }">
              <tr>
                <td>{{ variacao_valor.descricao }}</td>
                <td class="text-right">
                  <v-btn title="Editar" icon @click="editarValor(variacao_valor)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn title="Excluir" icon @click="perguntarExcluirValor(variacao_valor)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>

        <template v-slot:actions_left v-if="variacao.id != null">
          <v-btn depressed color="primary" @click="adicionarValor">
            <v-icon left>mdi-plus</v-icon>
            Adicionar
          </v-btn>
        </template>
        <template v-slot:actions_right>
          <v-btn text @click="fechar" :disabled="salvando">Cancelar</v-btn>
          <v-btn
            depressed
            color="primary"
            ref="btnConfirmar"
            :loading="salvando"
            :disabled="!form_valido_variacao"
            @click="confirmar"
          >Salvar</v-btn>
        </template>
      </z-dialogo>
    </v-form>

    <v-form v-model="form_valido_valor" lazy-validation ref="formularioValor">
      <z-dialogo ref="dialogoAdicionarValor" largura="300px" titulo="Opção" dividers persistent @abrir="$refs.formularioValor.resetValidation()">
        <template v-slot:conteudo>
          <v-row dense>
            <v-col cols="12">
              <z-text-field 
                v-model="variacao_valor.descricao" 
                ref="descricao" 
                label="Descrição" 
                autofocus
                upper
                :rules="[regras.campoObrigatorio]"
                @keyup.enter="confirmarValor"
              ></z-text-field>
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="$refs.dialogoAdicionarValor.fechar()" :disabled="salvando">Cancelar</v-btn>
          <v-btn depressed color="primary" ref="btnConfirmarValor" @click="confirmarValor" :loading="salvando" :disabled="!form_valido_valor">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>

    <z-dialogo-sim-nao ref="dialogoRemoverValor" titulo="Remover opção?" botaoSim="Remover" botaoNao="Cancelar" :loading="excluindo">
      A opção selecionada será removida do sistema.
    </z-dialogo-sim-nao>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import * as regras from "@/app/helpers/validacoes";

export default {
  name: "VariacoesForm",

  data() {
    return {
      headers: [
        { text: "Descrição", value: "descricao" },
        {
          text: "Opções",
          value: "",
          width: "200px",
          align: "center",
          sortable: false,
        },
      ],
      exibirValores: true,
      excluindo: false,
      salvando: false,
      form_valido_variacao: true,
      form_valido_valor: true,
      regras: { ...regras },
      adicionando: false
    };
  },

  computed: {
    ...mapState(["loading"]),
    ...mapState("variacoes", ["variacao", 'variacao_valor', 'valores']),
  },

  methods: {
    ...mapActions("variacoes", [
      "listar",
      "excluir",
      "abrir",
      "atualizar",
      "salvar",
      'abrirValor', 
      'atualizarValor', 
      'salvarValor',
      'excluirValor', 
    ]),

    abrir() {
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.Variacao.resetValidation();
      this.$refs.dialogo.fechar();
    },

    async confirmar() {
      if (!this.$refs.Variacao.validate()) {
        return false;
      }

      try {
        this.salvando = true;

        if (this.variacao.id) {
          await this.atualizar(this.variacao);
          this.$eventbus.notificar("Variação atualizado.");
        } else {
          await this.salvar(this.variacao);
          this.$eventbus.notificar("Variação cadastrado com sucesso.");
        }

        this.fechar();
      } catch (error) {
        this.$eventbus.erroSistema(
          "Não foi possível salvar esta variacao. Verifique os dados preenchidos."
        );
      } finally {
        this.salvando = false;
      }
    },

    adicionarValor() {
      this.$store.commit('variacoes/ZERAR_VALOR');
      this.$refs.dialogoAdicionarValor.abrir();
    },

    async editarValor(variacao_valor) {
      this.$store.commit('variacoes/EDITAR_VALOR', variacao_valor);
      this.$refs.dialogoAdicionarValor.abrir();
    },

    async confirmarValor() {
      if (!this.$refs.formularioValor.validate()) {
        return false;
      }

      try {
        this.salvando = true;

        if (this.variacao_valor.id) {
          await this.atualizarValor(this.variacao_valor);
        } else {
          this.variacao_valor.variacao_id = this.variacao.id;
          await this.salvarValor(this.variacao_valor);
        }

        this.$refs.dialogoAdicionarValor.fechar();
        this.$eventbus.notificar('Valor variação salvo com sucesso');
      } catch (error) {
        this.$eventbus.notificarErro('Não foi possível salvar este valor. Verifique os dados preenchidos.', error);
        throw error;
      } finally {
        this.salvando = false;
      }
    },

    perguntarExcluirValor(variacao_valor) {
      this.$refs.dialogoRemoverValor.abrir().then(async (response) => {
        if (response == true) {
          try {
            this.excluindo = true;
            await this.excluirValor(variacao_valor.id);
            this.$refs.dialogoRemoverValor.fechar();
            this.$eventbus.notificar('Valor excluído com sucesso!');
          } catch (error) {
            this.$eventbus.notificar('Não foi possível excluir o valor!');
            throw error;
          } finally {
            this.excluindo = false;
          }
        }
      });
    },
  },
};
</script>

<style scoped></style>
